import { Loadable } from '@/components/loaders';
import { useWorkspace } from '@/features/workspaces/hooks';
import { Audience } from '@/models/audiences';
import { AudienceExtractionStatus, useGetAudienceExtractionStatusQuery } from '@/services/endpoints/audiences';
import { FC } from 'react';
import { DownloadAudienceButton } from '../tabs/DownloadAudienceButton/DownloadAudienceButton';
import { DownloadingAudienceButton } from '../tabs/DownloadAudienceButton/DownloadingAudienceButton';
import { RequestAudienceDownloadButton } from '../tabs/DownloadAudienceButton/RequestAudienceDownloadButton';

type DownloadAudienceButtonProps = {
  audience?: Audience;
};

export const DownloadAudience: FC<DownloadAudienceButtonProps> = ({ audience }) => {
  const workspace = useWorkspace();

  const { data, isFetching } = useGetAudienceExtractionStatusQuery(
    {
      workspaceId: workspace.id,
      audienceId: audience.id,
    },
    {
      pollingInterval: 1000 * 60 * 2,
    }
  );

  return (
    <div className='grid gap-y-2'>
      <Loadable isLoading={isFetching}>
        {[AudienceExtractionStatus.NotFound, AudienceExtractionStatus.Error].includes(data?.status) ? (
          <RequestAudienceDownloadButton audience={audience} />
        ) : [AudienceExtractionStatus.Pending, AudienceExtractionStatus.Running].includes(data?.status) ? (
          <DownloadingAudienceButton />
        ) : (
          <DownloadAudienceButton audienceId={audience.id} />
        )}
      </Loadable>
    </div>
  );
};
